import React, { useMemo, useState, useEffect } from "react";

import { PAYMENT_DETAIL_CRYPTO_LIST_API } from "const/apiMethods";
import { checkPermissionsFor } from "store/storeHelpers";
import {
    getAmountLimitMin,
    getDefaultPickedCurrencyKey,
} from "components/Payments";
import { Spacer } from "components/base/Spacer";
import Page from "components/base/Page";
import PaymentsTrafficReportsSection from "./PaymentsTrafficReportsSection/PaymentsTrafficReportsSection";
import ModalAddPayment from "../PaymentDetails/ModalAddPaymentDetail";
import PaymentsRequestSection from "./PaymentsRequestSection/PaymentsRequestSection";
import ModalRequestPayment from "./ModalRequestPayment";
import PaymentsListSection from "./PaymentsListSection/PaymentsListSection";


export default ({
    service,
    permissions,

    paymentItems,
    paymentItemsLoading,

    paymentRequestItems,
    paymentRequestLoading,

    paymentTrafficReportsItems,
    paymentTrafficReportsLoading,

    paymentDetailsItems,
    accountInfo,
    accountJoinList,

    organizationTypeList,
    cryptoList,
    countryList,
    currencyList,
    paymentMethodList,
    globalSettings,

    // API methods
    getAccount,
    getPaymentRequestList,
    requestPayment,
    rejectPaymentRequest,
    getPaymentList,
    getTrafficReportsList,
    getPaymentDetailsList,
    getPaymentDetailsCryptoList,
    createPaymentDetails,
    modifyPaymentDetails,
    setReadyForPayment,
}) => {
    const [showModalRequestPayment, setShowModalRequestPayment] = useState(false);
    const [requestPaymentFormValue, setRequestPaymentFormValue] = useState({ amount: 0 });
    const [showModalAddPaymentDetail, setShowModalAddPaymentDetail] = useState(false);
    const [dropdownVisibility, setDropdownVisibility] = useState(true);
    const [pickedCurrencyKey, setPickedCurrencyKey] = useState(null);

    const billingCurrencyList = accountInfo?.billing_currency_list;

    useEffect(() => {
        if (checkPermissionsFor(PAYMENT_DETAIL_CRYPTO_LIST_API)) {
            getPaymentDetailsCryptoList();
        }
    }, [permissions, getPaymentDetailsCryptoList]);

    useEffect(() => {
        setPickedCurrencyKey(getDefaultPickedCurrencyKey(accountJoinList));
    }, [accountJoinList]);

    // set payment detail amount min limit
    const amountLimitMin = useMemo(() => {
        return getAmountLimitMin(
            requestPaymentFormValue.payment_detail_id,
            paymentDetailsItems,
            paymentMethodList
        );
    }, [requestPaymentFormValue.payment_detail_id, paymentMethodList, paymentDetailsItems]);

    const openModalRequestPayment = () => {
        setShowModalRequestPayment(true);
    };

    const closeModalRequestPayment = () => {
        setShowModalRequestPayment(false);

        const defaultPickedCurrencyKey = getDefaultPickedCurrencyKey(accountJoinList);

        if (!defaultPickedCurrencyKey) {
            setPickedCurrencyKey(null);
        }
    };

    const handleShowModalAddPaymentDetail = () => {
        setShowModalAddPaymentDetail(true);
        setDropdownVisibility(false);
    };

    const closeModalAddPaymentDetail = (value) => {
        if (value) {
            setRequestPaymentFormValue(prev => ({
                ...prev,
                payment_detail_id: value.payment_detail.id
            }));
        }
        setShowModalAddPaymentDetail(false);
        setDropdownVisibility(true);
    };

    const changeReadyForPayment = (amount) => {
        setReadyForPayment(amount);
    };

    const { currency_name: currencyName } = accountInfo || {};

    return (
        <Page>
            <PaymentsRequestSection
                {...{
                    permissions,
                    paymentRequestItems,
                    paymentRequestLoading,
                    rejectPaymentRequest,
                    getPaymentRequestList,
                    openModalRequestPayment,
                    currencyName,
                    setReadyForPayment,
                    readyForPayment: 0,
                    updateAccount: getAccount
                }}
            />

            <Spacer size={30} />
            <PaymentsListSection
                {...{
                    permissions,
                    paymentItems,
                    paymentItemsLoading,
                    currencyName,
                    getPaymentList
                }}
            />

            <Spacer size={30} />
            <PaymentsTrafficReportsSection
                {...{
                    service,
                    permissions,
                    accountJoinList,
                    paymentTrafficReportsItems,
                    paymentTrafficReportsLoading,
                    openModalRequestPayment,
                    currencyName,
                    globalSettings,
                    getTrafficReportsList,
                }}
            />


            <ModalRequestPayment
                show={showModalRequestPayment}
                onClose={closeModalRequestPayment}
                formValue={requestPaymentFormValue}
                setFormValue={setRequestPaymentFormValue}
                amountLimitMin={amountLimitMin}
                onSuccess={(readyForPayment, amount) => {
                    changeReadyForPayment(+readyForPayment - amount);
                    getAccount();
                }}
                {...{
                    service,
                    currencyList,
                    currencyName,
                    requestPayment,
                    accountJoinList,
                    pickedCurrencyKey,
                    setPickedCurrencyKey,
                    billingCurrencyList,
                    paymentDetailsItems,
                    getPaymentRequestList,
                    getPaymentDetailsList,
                    dropdownVisibility,
                    handleShowModalAddPaymentDetail
                }}
            />

            {showModalAddPaymentDetail && <ModalAddPayment
                show={showModalAddPaymentDetail}
                onClose={closeModalAddPaymentDetail}
                accountJoinList={accountJoinList}
                {...{
                    organizationTypeList,
                    cryptoList,
                    countryList,
                    currencyList,
                    paymentMethodList,
                    pickedCurrencyKey,
                    createPaymentDetails,
                    modifyPaymentDetails,
                    getPaymentDetailsList
                }}
                defaultFormValue={{ pm_key: 1, ot_key: 1, cur_key: pickedCurrencyKey }}
            />}

        </Page>
    )
};